const ErrorData = () => {
  return(
    <div>No Content</div>
  );
}
  
export default ErrorData;